"use strict";

exports.__esModule = true;
exports.getMenuByUrl = getMenuByUrl;

function getMenuByUrl(root = undefined, menu = [], urls = {}, level = 0) {
  menu.forEach(item => {
    item.level = level;

    if (root && item.path) {
      item.url = root + item.path;
    } else if (root) {
      item.url = root;
    }

    if (item.url) {
      urls[item.url] = item;
    }

    if (item.children) {
      urls = getMenuByUrl(root, item.children, urls, level++);
    }
  });
  return urls;
}